import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faCloudUpload } from '@fortawesome/pro-light-svg-icons/faCloudUpload';
import { faServer } from '@fortawesome/pro-light-svg-icons/faServer';
import { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn';
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faListUl } from '@fortawesome/pro-light-svg-icons/faListUl';
import { faSitemap } from '@fortawesome/pro-light-svg-icons/faSitemap';

export const academiaPlans = [
  {
    id: 1,
    plandHeading: 'Consumer Plans',
    planDescription: 'Enhance your research, learning, and teaching with myriad features and tools',
    planIcon: faUsers,
    link: '/pricing',
    linkText: 'Browse Plans',
  },
  {
    id: 2,
    plandHeading: 'Real-time API',
    planDescription: 'Take the programmatic approach to conducting research and managing knowledge',
    planIcon: faCloudUpload,
    link: '/products/api/financial-news/pricing-api/commercial',
    linkText: 'Browse Tiers',
  },
  {
    id: 3,
    plandHeading: 'Historical Data Sets',
    planDescription: 'Backtest trading models and support your analysis with detailed historical data',
    planIcon: faServer,
    link: '/products/api/financial-news/pricing-historical',
    linkText: 'Choose Data',
  },
  {
    id: 4,
    plandHeading: 'Single Sign-on (SSO)',
    planDescription: 'Is available to provide seamless access to students, faculty, etc',
    planIcon: faSignIn,
    comingSoon: true,
  },
];

export const academicNeedsHeadItems = [
  {
    id: 1,
    text: (
      <>
        Less reading time.
        <br />
        More focus on the essentials
      </>
    ),
    icon: faClock,
  },
  {
    id: 2,
    text: (
      <>
        One paid subscription.
        <br />
        Many paid publications
      </>
    ),
    icon: faListUl,
  },
  {
    id: 3,
    text: (
      <>
        250, 000+ entities.
        <br />
        Popular and niche topics
      </>
    ),
    icon: faSitemap,
  },
];

export const studentResearchesInfo = [
  {
    id: 1,
    text: 'Big Data unveils otherwise obscured information and trends',
  },
  {
    id: 2,
    text: (
      <>
        Access more with paywall-free
        <br />
        Premium content
      </>
    ),
    tooltip: true,
  },
  {
    id: 3,
    text: 'Stay informed and maintain an edge over career competition',
  },
  {
    id: 4,
    text: 'Extracted and structured filings data for simple and convenient use',
  },
];

export const classRoom = [
  {
    id: 1,
    text: 'Bring real-time, real-world data into the learning experience',
  },
  {
    id: 2,
    text: 'Demonstrate the descriptive and predictive power of analytics',
  },
  {
    id: 3,
    text: 'Organise lessons with filings, news, and other content in one place',
  },
  {
    id: 4,
    text: 'Dive deep into our Big Data reservoir for thought-provoking material',
  },
];

export const academicTabs = [
  {
    id: 1,
    tabTitle: 'Computer Science',
    eventKey: 'science',
    listItems: [
      (
        <>
          Live, structured,
          {' '}
          <span style={{ fontStyle: 'italic' }}>prelabelled</span>
          {' '}
          data for convenient ingestion
        </>
      ),
      'Natural language understanding (NLU) tags for linguistic analysis',
      'Sentiment analysis, spam probabilities, and other analytics for decision-making algorithms',
      'An API component for simpler interfacing',
      'Filings and historical data for model testing',
    ],
  },
  {
    id: 2,
    tabTitle: 'Marketing',
    eventKey: 'marketing',
    listItems: [
      'Track specific products and companies',
      'Watch PR and marketing campaigns unfold in the press and on Social Media (Twitter)',
      'Use Sentiment and Trending to understand how announcements, campaigns, and filings are received',
    ],
  },
  {
    id: 3,
    tabTitle: 'Management',
    eventKey: 'management',
    listItems: [
      'Analyze how C-Suite execs speak publicly',
      'Capture management concerns, direction, and outlook from company filings and statements',
    ],
  },
  {
    id: 4,
    tabTitle: 'Psychology',
    eventKey: 'psychology',
    listItems: [
      'Observe social psychology in action through the far-reaching international financial system',
      'Analyze individual user sentiments and reactions to market and company changes or announcements',
      'Study psycholinguistics with structured NLU data',
    ],
  },
  {
    id: 5,
    tabTitle: 'Mathematics',
    eventKey: 'mathematics',
    listItems: [
      'Observe and study the Level 2 chaotic systems of the stock markets and international economics in real-time',
      'Model price movements based on analytics, past price action, current news, or NLU data',
      'Utilize our API for convenient ingestion of structured data like Sentiment, Spam, NLU tags, prices, and filings',
    ],
  },
  {
    id: 6,
    tabTitle: 'Linguistics',
    eventKey: 'linguistics',
    listItems: [
      'Leverage our NLP engine to receive structured, tagged data',
      'Analyse content reduction through our Summarisation tool',
      'Receive enterprise-level machine translation at retail costs',
      'Monitor sentiment and spam and their associations with NLU tags',
    ],
  },
  {
    id: 7,
    tabTitle: 'Law',
    eventKey: 'law',
    listItems: [
      'Track domestic and international laws, and translate when necessary',
      'Watch how markets react to court decisions and legislative votes',
      'Capture relevant qualitative data, like news stories, and quantitative data, like Sentiment, Spam, and Trending Analytics',
    ],
  },
];
